export enum AdditionalInformation {
  Profile,
  Document,
  CheckList,
  EssayPilot,
  General,
  MyInstitute,
  Mindler
}

//TODO: Remove MyInstitute and Mindler
export const AdditionalInformationDescription: { [key in AdditionalInformation]: string } = {
  [AdditionalInformation.Profile]: "Profile",
  [AdditionalInformation.Document]: "Document",
  [AdditionalInformation.CheckList]: "Check List",
  [AdditionalInformation.EssayPilot]: "EssayPilot",
  [AdditionalInformation.General]: "General",
  [AdditionalInformation.MyInstitute]: "MyInstitute",
  [AdditionalInformation.Mindler]: "Mindler",
};
